import React from 'react';
import { Pill } from './Pill';
interface SectionHeadingProps {
  eyebrow?: string;
  eyebrowTone?: 'gold' | 'track' | 'outline';
  title: React.ReactNode;
  lead?: React.ReactNode;
  align?: 'center' | 'left';
  className?: string;
}
export function SectionHeading({
  eyebrow,
  eyebrowTone = 'gold',
  title,
  lead,
  align = 'center',
  className = ''
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl';
  return <div className={`${alignment} ${className}`} data-id="element-160" data-mp="gjgj8u6d7cmj">
      {eyebrow ? <Pill tone={eyebrowTone} data-id="element-161" data-mp="giwyz6t8sc5c">{eyebrow}</Pill> : null}
      <h2 className={`font-display text-[2rem] font-bold leading-[1.1] text-ivory sm:text-4xl lg:text-[2.75rem] ${eyebrow ? 'mt-5' : ''}`} data-id="element-162" data-mp="1v3ou1mxe1u5">
        {title}
      </h2>
      {lead ? <p className={`mt-4 font-sans text-base leading-relaxed text-stone ${align === 'center' ? 'mx-auto max-w-readable' : 'max-w-readable'}`} data-id="element-163" data-mp="uj7uwo9esgxd">
          {lead}
        </p> : null}
    </div>;
}